const en = {
  common: {
    home: "Home",
    materials: "Materials",
    rateCard: "Rate Card",
    cart: "Cart",
    myBookings: "My Bookings",
    login: "Login",
    signup: "Sign Up",
    dashboard: "Dashboard",
    settings: "Settings",
    logout: "Logout",
    save: "Save",
    loading: "Loading...",
  },
  header: {
    brand: "MistriBazaar",
  },
  settings: {
    title: "Settings",
    subtitle: "Manage your profile, language, address, and account preferences.",
    profileSection: "Profile",
    languageSection: "Language",
    addressSection: "Saved Address",
    accountSection: "Account",
    fullName: "Full Name",
    phone: "Phone Number",
    email: "Email",
    city: "City",
    preferredLanguage: "Preferred Language",
    flatHouseNo: "Flat No / House No",
    streetArea: "Street / Area",
    state: "State",
    country: "Country",
    pincode: "Pincode",
    role: "Role",
    uniqueId: "Unique ID",
    saveProfile: "Save Profile",
    saveAddress: "Save Address",
    accountDetails: "Account Details",
  },
  home: {
    heroTitle: "MistriBazaar",
    heroText:
      "Book services, buy materials, build your house, and reduce the headache of local coordination, hidden costs, and uncertain timelines.",
    buyMaterials: "Buy Materials",
    buildYourHouse: "Build Your House",
    exploreMembership: "Explore Membership",
    services: "Services",
    about: "About",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    terms: "Terms & Conditions",
  },
};

export default en;